export default "__VITE_ASSET__Cml4xEVm__"